import { addStyles, DefaultTheme, rgba } from '../theme';
import { ColorPaletteOrange } from '../theme.palette';

const RAIL_WIDTH = 40;

export const CSS = {
	rail: 'c-CollapsedRail',
	railLabel: 'c-CollapsedRail__label',
};

export const Style = {
	// Toolbar colour and elevation, so the rail reads as the same surface collapsed.
	[CSS.rail]: {
		flex: `0 0 ${RAIL_WIDTH}px`,
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'center',
		padding: `${DefaultTheme.space(1)} 0`,
		'background-color': rgba(ColorPaletteOrange.C100),
		'box-shadow': DefaultTheme.shadow.box.dp4,
		overflow: 'hidden',
	},
	[CSS.railLabel]: {
		'writing-mode': 'vertical-rl',
		'font-family': DefaultTheme.font.familyCondensed,
		'font-size': '120%',
		'white-space': 'nowrap',
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'user-select': 'none',
		'margin-top': DefaultTheme.space(1),
		// Claim the leftover height so the ellipsis has something to trim against.
		flex: '1 1 auto',
		'min-height': 0,
	},
};

addStyles(Style);
